import axios from "axios";
import { DECIMAL } from "../config";

// const apiUrl = "http://192.168.79.131:3000"; // dev url
// const apiUrl = "http://127.0.0.1:9000"; // local dev url
const apiUrl = "https://sei.texaglo.com";
const nutUrl = "https://backend.nut.market";

export const checkHealth = async () => {
  try {
    const response = await axios.get(`${apiUrl}/checkhealth`);
    return response.data;
  } catch (error) {
    console.error("Error checking health:", error);
    throw error;
  }
};

export const uploadAvatar = async (data) => {
  try {
    const response = await axios.post(`${apiUrl}/api/avatar`, data);
    return response.data;
  } catch (error) {
    console.error("Error uploadAvatar:", error);
    throw error;
  }
};

export const getUserNft = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/nft?wallet=${data?.wallet}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting user:", error);
    throw error;
  }
};

export const getUser = async (data) => {
  try {
    const response = await axios.get(`${apiUrl}/api/user`, data);
    return response.data;
  } catch (error) {
    console.error("Error getting user:", error);
    throw error;
  }
};

export const newUser = async (data) => {
  try {
    const response = await axios.post(`${apiUrl}/api/user`, data);
    return response.data;
  } catch (error) {
    console.error("Error newUser:", error);
    throw error;
  }
};

export const updateUser = async (data) => {
  try {
    const response = await axios.patch(`${apiUrl}/api/user`, data);
    return response.data;
  } catch (error) {
    console.error("Error updateUser:", error);
    throw error;
  }
};

// Item Details Endpoints
export const getItemDetails = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/get_details?collection=${data?.collection}&assetid=${data?.assetid}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting item details:", error);
    throw error;
  }
};

// Item Activities Endpoints
export const getItemActivities = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/get_item_activities?collection=${data?.collection}&assetid=${data?.assetid}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting item activities:", error);
    throw error;
  }
};

// Listings Endpoints
export const getListings = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/listings`);
    return response.data;
  } catch (error) {
    console.error("Error getting listings:", error);
    throw error;
  }
};

export const getAllCollection = async (sub) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/all_collections?subquery=${sub}&collection=all`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting listings:", error);
    throw error;
  }
};

export const getOwnedCollection = async (address) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/owned_collections?owner=${address}`
    );

    return response.data;
  } catch (error) {
    console.error("Error getting owned collections: ", error);
    throw error;
  }
};

export const getListsFromCollectionPalletPerPage = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/get_page_listings?collection=${data.collection}&subquery=${data.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting page ListsFromCollection:", error);
    throw error;
  }
};

export const getAllListsFromCollectionPallet = async (collection, count) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/get_all_listings?collection=${collection}&subquery=${count}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting all ListsFromCollection:", error);
    throw error;
  }
};

// Item Bid User Endpoints
export const getUserBids = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/bid_user?user=${data?.wallet}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting user bids:", error);
    throw error;
  }
};

export const getBids = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/bid?collection=${data?.collection}&assetid=${data?.assetid}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting item bids:", error);
    throw error;
  }
};

export const createBid = async (data) => {
  let currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() + 10);
  console.log(data);

  const listingData = {
    offer: true,
    contract: data?.collection,
    token_id: Number(data?.token_id),
    seller: data?.seller,
    expires: parseInt(currentDate.getTime() / 1000),
    price: data?.price,
    currency: "Sei",
    buyer: data?.address,
    metadata: data?.metadata,
  };

  console.log(listingData);

  try {
    const response = await axios.post(`${apiUrl}/api/bid`, listingData);
    return response.data;
  } catch (error) {
    console.error("Error creating bid:", error);
    throw error;
  }
};

export const unMakeBid = async (data) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/api/bid?listing_id=${data?.listing_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting bid:", error);
    throw error;
  }
};

export const updateBid = async (data) => {
  try {
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 10);

    const updateData = {
      listing_id: data?.listing_id,
      sold: "0",
      mode: "Price",
      buyer: "",
      price: data?.price?.toString(),
      expiration: (currentDate.getTime() / 1000).toString(),
    };
    console.log(updateData);

    const response = await axios.patch(`${apiUrl}/api/bid`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating bid:", error);
    throw error;
  }
};

export const acceptBid = async (data) => {
  try {
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 10);

    const updateData = {
      listing_id: data?.id,
      sold: parseInt(new Date().getTime() / 1000).toString(),
      mode: "Buy",
      buyer: data?.address,
      price: data?.price?.toString(),
      expiration: parseInt(new Date().getTime() / 1000).toString(),
    };
    console.log(updateData);

    const response = await axios.patch(`${apiUrl}/api/bid`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating listing:", error);
    throw error;
  }
};

export const createListing = async (data) => {
  let currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() + 10);

  const listingData = {
    offer: false,
    contract: data?.contract,
    token_id: Number(data?.token_id),
    seller: data?.address,
    expires: parseInt(currentDate.getTime() / 1000),
    price: parseInt(data?.price * DECIMAL),
    currency: "Sei",
    buyer: "",
    metadata: JSON.stringify({
      image: data?.image,
      properties: data?.properties ? data?.properties : data?.attributes,
      name: data?.name,
      description: data?.description,
    }),
  };

  try {
    const response = await axios.post(`${apiUrl}/api/listings`, listingData);
    return response.data;
  } catch (error) {
    console.error("Error creating listing:", error);
    throw error;
  }
};

export const buy = async (data) => {
  try {
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 10);

    const updateData = {
      listing_id: data?.id,
      sold: parseInt(new Date().getTime() / 1000).toString(),
      mode: "Buy",
      buyer: data?.address,
      price: data?.price?.toString(),
      expiration: parseInt(new Date().getTime() / 1000).toString(),
    };
    console.log(updateData);

    const response = await axios.patch(`${apiUrl}/api/listings`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating listing:", error);
    throw error;
  }
};

export const cartBuy = async (data) => {
  try {
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 10);
    const result = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i]?.marketplace != "pallet") {
        result.push({
          listing_id: data[i]?.id,
          sold: parseInt(new Date().getTime() / 1000).toString(),
          mode: "Buy",
          buyer: data[i]?.address,
          price: data[i]?.price?.toString(),
          expiration: parseInt(new Date().getTime() / 1000).toString(),
        });
      }
    }
    console.log("cart buy", result);

    const response = await axios.post(`${apiUrl}/api/cart`, { cart: result });
    return response.data;
  } catch (error) {
    console.error("Error updating listing:", error);
    throw error;
  }
};

export const updateListing = async (data) => {
  try {
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 10);

    const updateData = {
      listing_id: data?.listing_id,
      sold: "0",
      mode: "Price",
      buyer: "",
      price: data?.price?.toString(),
      expiration: (currentDate.getTime() / 1000).toString(),
    };
    console.log(updateData);

    const response = await axios.patch(`${apiUrl}/api/listings`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating listing:", error);
    throw error;
  }
};

export const deleteListing = async (data) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/api/listings?listing_id=${data?.listing_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting listing:", error);
    throw error;
  }
};

export const getCollectionListings = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/collection_listings?subquery=${Number(
        data?.subquery
      )}&collection=${data?.collection}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting listings:", error);
    throw error;
  }
};

export const getCollectionListingsCount = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/collection_listings_count?collection=${data?.collection}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting listings:", error);
    throw error;
  }
};

// User Listings Endpoint
export const getUserListings = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/user_listings?user=${data?.user}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting user listings:", error);
    throw error;
  }
};

// User Purchases Endpoint
export const getUserPurchases = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/user_purchases`);
    return response.data;
  } catch (error) {
    console.error("Error getting user purchases:", error);
    throw error;
  }
};

// User Offers Endpoint
export const getUserOffers = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/user_offers`);
    return response.data;
  } catch (error) {
    console.error("Error getting user offers:", error);
    throw error;
  }
};

// get Collection Acitivity
export const getCollectionActivity = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/collection_activity?collection=${data?.collection}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting collection activity:", error);
    throw error;
  }
};

// get Total Acitivity
export const getTotalActivity = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/all_activity?collection=all&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting total acitivity:", error);
    throw error;
  }
};

// get User Acitivity
export const getUserActivity = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/get_user_activity?user=${data?.user}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting user acitivity:", error);
    throw error;
  }
};

// Collections Endpoints
export const getCollectionsByContract = async (data) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/collection?collection=${data?.collection}&subquery=${data?.subquery}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting collections by contract:", error);
    throw error;
  }
};

export const createCollection = async (collectionData) => {
  console.log("create collection = ", collectionData);
  try {
    const response = await axios.post(
      `${apiUrl}/api/collection`,
      collectionData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating collection:", error);
    throw error;
  }
};

export const updateCollection = async (collectionId, updateData) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/api/collections/${collectionId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating collection:", error);
    throw error;
  }
};

export const getCollectionsByName = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/collection_name?subquery=0&collection=sei1ge6fgvr3n6z0xqjkmrhncmcl6cmfz58qgzagsd`
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error getting collections by name:", error);
    throw error;
  }
};

export const getToken = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/token`);
    return response.data;
  } catch (error) {
    console.error("Error getting token:", error);
    throw error;
  }
};

export const createToken = async (tokenData) => {
  try {
    const response = await axios.post(`${apiUrl}/api/token`, tokenData);
    return response.data;
  } catch (error) {
    console.error("Error creating token:", error);
    throw error;
  }
};

export const updateToken = async (tokenId, updateData) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/api/token/${tokenId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating token:", error);
    throw error;
  }
};

export const getCollectionDetail = async (contract) => {
  try {
    const response = await axios.get(
      `${nutUrl}/get-collection-detail?contract=${contract}`
    );
    return response.data.result;
  } catch (error) {
    console.error("Error get collection detail:", error);
    throw error;
  }
};

export const getPalletNfts = async (contract, page, pageSize) => {
  try {
    const response = await axios.get(
      `${nutUrl}/get-collection-nfts?contract=${contract}&page=${page}&pageSize=${pageSize}`
    );

    return response.data.result;
  } catch (error) {
    console.error("Error updating token:", error);
    throw error;
  }
};

export const getOwnedNfts = async (collections, owner) => {
  try {
    const response = await axios.post(
      `${nutUrl}/get-owned-nfts`, 
      {
        collections,
        owner
      }
    );
    console.log('owned nfts = ', response.data)
    return response.data.result;
  } catch (error) {
    console.error("Error owned nfts:", error);
    throw error;
  }
};

export const getUserNfts = async (collections, owner) => {
  try {
    const response = await axios.post(
      `${nutUrl}/get-user-nfts?`, {
        owner, collections
      }
    );  
    console.log('user nfts = ', response.data)
    return response.data.result;
  } catch (error) {
    console.error("Error user nfts:", error);
    throw error;
  }
};